export default __webpack_public_path__ + "6b055f9006a1c7e6ce0ac89f70fe27d7.svg";